.lock {
  margin-bottom: 16px;
  font-size: 13px;
}

.icon {
  color: var(--vkui--color_accent_gray);
}

.widgetLockBan {
  text-align: center;
}

.widgetPanelSeparator {
  margin-top: auto;
}

.widgetLockLink {
  color: var(--widget-lock-link);
}
